export default __webpack_public_path__ + "static/media/logo.5da5c427.png";